import { getItem } from "../services/localStorageService";
import { AUTH_KEY } from "../consts/constants";

export default function getToken() {
  return getItem(AUTH_KEY) || "";
}
